import React from 'react';

import moment from 'moment';

require('moment-timezone');

export interface DateFormatterProps {
  children?: any;
}

export const DateFormatter = ({ children }: DateFormatterProps): JSX.Element => {
  if (typeof children === 'number') {
    const rawDate = moment(children);
    const dateValue = rawDate.tz('America/New_York');
    return <span>{dateValue.format('MMM D, h:mm A')}</span>;
  }
  return children;
};

export default DateFormatter;
